import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Card } from 'react-bootstrap';

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import { useDispatch, useSelector } from "react-redux";

import { certificateActions } from "../../../_actions";

import Spinner from "../Spinner";

import "./CertificatesList.css";

const CertificatesList = (props) => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const certificates = useSelector((state) => state.certificates);
  const loading = useSelector((state) => state.certificates.loading);
  const dispatch = useDispatch();

  const certificateListData = certificates.items ? certificates.items : [];

  const mounted = useRef();

  useEffect(() => {
    // only on componentDidMount event
    if (!mounted.current) {
      mounted.current = true;
      dispatch(certificateActions.getAll());
    } else {
      // do componentDidUpate logic
    }
  }, [dispatch]);

  const listItems = certificateListData.map((item, index) => {
    const { ...itemData } = item;
    return (
      <Card style={{width:'21rem', marginRight:'30px', marginBottom:'30px'}} key={index} >
        <Card.Img variant="top"
          src={require("../../../static/images/certificates/"+itemData.imageFileName)}
          onClick={() => {setPhotoIndex(index);setIsOpen(true);}}
          style={{height:"240px"}}
          alt={itemData.name}
        />
      </Card>
    );
  });

  if (loading) {
    return <Spinner />;
  }

  const lightboxCustomStyles = {
    overlay: {
        top: '75px'
    }
  }

  return (
    <Container className="certificates-list">
      <Row className='justify-content-md-center certificate-list-row'>
        {listItems}
      </Row>
      {isOpen && (
        <Lightbox
          mainSrc={String(require("../../../static/images/certificates/"+certificateListData[photoIndex].imageFileName))}
          nextSrc={String(certificateListData[(photoIndex + 1) % certificateListData.length].imageFileName)}
          prevSrc={String(certificateListData[(photoIndex + certificateListData.length - 1) % certificateListData.length].imageFileName)}
          onCloseRequest={() => {setIsOpen({ isOpen: false });window.location.reload();}}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + certificateListData.length - 1) % certificateListData.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % certificateListData.length)}
          enableZoom={false}
          reactModalStyle={lightboxCustomStyles}
        />
      )}
    </Container>
  );
};

export default CertificatesList;
